import * as React from "react";
import {ISvgIconProps, SvgIcon} from '../../../../basic-ui-components/icon/svg-icon/svg.icon';

export interface IGettingStartedIconProps extends ISvgIconProps {

}

export class GettingStartedIcon extends React.Component<IGettingStartedIconProps> {
    render() {
        return (
            <SvgIcon {...this.props}>
                <g fill="currentColor">
                    <path d="M12.196 6.841a4.203 4.203 0 1 1 -4.2 4.2 4.208 4.208 0 0 1 4.2 -4.2Zm0 7.207a3.003 3.003 0 1 0 -3 -3.007 3.007 3.007 0 0 0 3 3.007Z"/>
                    <path d="M12.199 3.4a7.626 7.626 0 0 1 7.618 7.618 7.741 7.741 0 0 1 -2.379 5.53l-0.018 0.018 -5.22 5.074 -5.211 -5.066A7.618 7.618 0 0 1 12.199 3.4Zm4.374 12.315a6.523 6.523 0 0 0 2.043 -4.698 6.418 6.418 0 1 0 -10.804 4.686l0.007 0.007 4.379 4.25Z"/>
                </g>
            </SvgIcon>
        );
    }
}
